import Styled from 'styled-components'

export const DivNavigate = Styled.nav`

`

export const Container = Styled.div`
border-bottom: 1px solid #C6C6C5; 
background-color: white;  
position: fixed;
top: 90px;
z-index: 1000;
width: 100%;
text-align: center;
display: inline-block;
`

export const Informations = Styled.div`
display:flex;
justify-content: center;
gap: 14%;
margin: 5px 0;

    p {
        display: flex;
        flex-direction: column;
        text-align: center;
        font-size: 16px;
        font-weight: bold;
       
    
        @media (max-width: 800px) {
        margin-right: -7px;
        margin-left: -7px;
        color: ${props => props.theme.primary};;
    }

    span {
        color: rgba(5, 9, 34, 0.6);
        font-size: 12px;
        font-weight: 400;
   }
}

@media(max-width: 800px) {
    gap: 45px;
}
`

export const ContainerDate = Styled.div`
display: flex;
justify-content: space-between;
margin-top: -10px;

.test{
    width: 60px;
}
`
